require("./cardPinCvvRequestView.scss");

// @ vendors
const React = require("react");
const { withRouter } = require('react-router-dom');
const PropTypes = require("prop-types");
const { connect } = require("react-redux");
// @ utilities
const {
    toFirstUppercase,
    nonNumericFilter
} = require("utilities/stringHelper");
const { FormattedText, formatText, getFinalTitle } = require("core/i18n").i18n;
const { cardConstants } = require("utilities/accessHelperConditions/cards");
const AccessHelper = require("utilities/accessHelper");
const { formatCardNumber } = require("utilities/cardsHelper");
const { PAGE_GENERIC, recordPath } = require("utilities/tagging");
const { changeBiocatchContext } = require("utilities/biocatch");
// @ actions
const cardsPinActions = require("actions/getCardsPin");
const cardCvvActions = require("actions/getCardCvv");
// @ commons
const { OKSectionBox } = require("commonsComponents/OKSectionBox");
const { OKHeaderSubPage } = require("commonsComponents/OKHeaderSubPage");
const { OKCover } = require("commonsComponents/OKCover");
// @ components
const { LoadingSection } = require("commonsComponents/loadingSection");
const SignaturePatternButton = require("components/signaturePattern/signaturePatternButton/signaturePatternButton");
const SignaturePattern = require("components/signaturePattern/signaturePattern")
    .SignaturePattern;
const CardShowAndHideSensitiveInformation = require("components/cards/cardShowAndHideSensitiveInformation/cardShowAndHideSensitiveInformation");
const CardDetailsSideBar = require("components/cards/cardDetailsSidebar/cardDetailsSidebar");
const CardPinCvvRequestError = require("components/cards/cardPinCvvRequestError/cardPinCvvRequestError");
const { OKLink } = require("commonsComponents/OKLink");
const TutorialLauncher = require("components/tutorial/tutorialLauncher");
const CardHeaderDetails = require("components/cards/cardHeaderDetails/cardHeaderDetails");
const PrintableGenericDocument = require("components/contactCenter/printer/printableDocuments/printableGenericDocument/printableGenericDocument");
const PreLeaveModalComponent = require("components/preLeaveModalComponent/preLeaveModalComponent");
// @ constants
const {
    CARD_PIN_REQUEST_ID,
    CARD_CVV_REQUEST_ID
} = require("constants/operationTypes");
const { GRAPHIC_TUTOR_TYPE_4 } = require("constants/index");
const REQUEST_TYPE_PIN = "pin";
const carsRequestIdType = {
    pin: CARD_PIN_REQUEST_ID,
    cvv: CARD_CVV_REQUEST_ID
};
const biocatch = require("constants/biocatch");

class CardPinCvvRequestView extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    componentDidMount() {
        const {
            history,
            immCards,
            match: { params: { cardId, type } }
        } = this.props;
        const immCard = immCards.getIn(["byId", cardId]);
        const isCVVRequest = type !== REQUEST_TYPE_PIN;

        AccessHelper.allowAccess(cardConstants.CARD_PIN_CVV_REQUEST, {
            immCard,
            isCVVRequest
        }, history);

        const tagging = immCard.get("tagging");
        const pathTagging = isCVVRequest
            ? "tarjeta/consulta-cvv"
            : "tarjeta/consulta-pin";
        recordPath(pathTagging, PAGE_GENERIC, "", "", tagging);
    }

    componentWillUnmount() {
        const {
            match: { params: { cardId, type } },
            resetPin,
            resetCvv
        } = this.props;
        const isPin = type === REQUEST_TYPE_PIN;

        if (cardId) {
            if (isPin) {
                resetPin(cardId);
            } else {
                resetCvv(cardId);
            }
        }
    }

    buildTwoColumnSection(immCard, content) {
        return (
            <div>
                {/* >> CONTENT DUPLICATED: REF-01 */}
                <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                    <CardDetailsSideBar immCard={immCard} />
                </div>
                {/* CONTENT DUPLICATED: REF-01 << */}
                <div className="col-md-12 col-lg-8">
                    <OKSectionBox>{content}</OKSectionBox>
                </div>
                {/* >> REF-01 */}
                <div className="hidden-xs hidden-sm hidden-md col-lg-4">
                    <CardDetailsSideBar immCard={immCard} />
                </div>
                {/* REF-01 << */}
            </div>
        );
    }

    handleSubmit() {
        const {
            match: { params: { cardId, type } },
            requestPin,
            requestCvv
        } = this.props;
        const isPin = type === REQUEST_TYPE_PIN;

        if (cardId) {
            if (isPin) {
                requestPin(cardId);
            } else {
                requestCvv(cardId);
            }
        }
    }

    isReady() {
        return false;
    }

    render() {
        const {
            match: { params: { cardId, type } },
            immCards,
            resetPin,
            setPinExpired,
            resetCvv,
            setCvvExpired,
            immPrinter
        } = this.props;
        const immCard = immCards.get("byId").get(cardId);

        let block;
        let sectionContent;

        if (immCard) {
            const isPin = type === REQUEST_TYPE_PIN;
            const request = isPin ? immCard.get("pin") : immCard.get("cvv");
            const codeSuccess = request.get("success");
            const hasError = !!request.get("error");
            const codeNumber = request.get("code");
            const subtitleLeft = formatText(`cards-${immCard.get("type")}`);
            const subtitleRight = immCard.get("alias").get("current");
            const typeKey = toFirstUppercase(type);
            const pageTitleKey = `breadcrumb-card${typeKey}RequestTitle`;
            const typeTutorial = isPin
                ? "cardsRequestPinTitle"
                : "cardsRequestCVVTitle";
            const tutorial = (
                <TutorialLauncher
                    type={GRAPHIC_TUTOR_TYPE_4}
                    title={formatText(`tutorials-${typeTutorial}`)}
                />
            );
            const mappingBreadcrumb = [
                {
                    text: formatText("breadcrumb-cards"),
                    url: "/myprofile/cards"
                },
                {
                    text: immCard.get("alias").get("current"),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText(pageTitleKey),
                    url: ""
                }
            ];

            let reset = resetPin;
            let setExpired = setPinExpired;
            if (!isPin) {
                reset = resetCvv;
                setExpired = setCvvExpired;
            }

            if (codeSuccess) {
                const textBack = formatText("signaturePattern-textBack", [
                    immCard.get("alias").get("current")
                ]);
                changeBiocatchContext(biocatch.SUCCESSFUL_OPERATION);
                sectionContent = this.buildTwoColumnSection(
                    immCard,
                    <CardShowAndHideSensitiveInformation
                        cardId={cardId}
                        codeNumber={codeNumber}
                        immCard={immCard}
                        reset={reset}
                        setExpired={setExpired}
                        title={formatText(`card${typeKey}Request-successTitle`)}
                        textBack={textBack}
                        messageShortNonExpired={formatText(
                            `card${typeKey}Request-shortNonExpiredMessage`
                        )}
                        messageNonExpired={formatText(
                            `card${typeKey}Request-nonExpiredMessage`
                        )}
                        messageExpired={formatText(
                            `card${typeKey}Request-expiredMessage`
                        )}
                        isPin={isPin}
                    />
                );
            } else if (hasError) {
                sectionContent = <CardPinCvvRequestError immCard={immCard} />;
            } else {
                const operationParams = {
                    pan: nonNumericFilter(immCard.get("number"))
                };
                const operationType = carsRequestIdType[type];
                const linkToCard = `/myprofile/cards/${cardId}/details`;
                const hiddenCardNumber = formatCardNumber(
                    immCard.get("number"),
                    4,
                    "*"
                );
                const acceptText = formatText(
                    "wizard-redirectConfirmationAcceptButton"
                );
                const cancelText = formatText(
                    "wizard-redirectConfirmationCancelButton"
                );
                const confirmationTitle = formatText(
                    "wizard-redirectConfirmationTitle"
                );
                const confirmationMessage = formatText(
                    "wizard-redirectConfirmationMessage"
                );

                sectionContent = this.buildTwoColumnSection(
                    immCard,
                    <article>
                        <PreLeaveModalComponent
                            confirmationMessage={confirmationMessage}
                            confirmationTitle={confirmationTitle}
                            acceptText={acceptText}
                            cancelText={cancelText}
                            isReady={this.isReady}
                        />
                        <header className="card-pin-cvv-request-view__header">
                            <FormattedText
                                value={`card${typeKey}Request-title`}
                            />
                        </header>
                        <section className="card-pin-cvv-request-view__informative-text">
                            <FormattedText
                                value={`card${typeKey}Request-informativeText`}
                            />
                            <span className="card-pin-cvv-request-view__value">
                                {hiddenCardNumber}
                            </span>
                        </section>
                        <SignaturePattern
                            operationType={operationType}
                            operationParams={operationParams}
                        />
                        <footer className="card-pin-cvv-request-view__footer">
                            <div className="card-pin-cvv-request-view__cancel-button">
                                <OKLink
                                    modifier="inherit-styles"
                                    to={linkToCard}
                                >
                                    <FormattedText
                                        value={`cardRequests-cancel`}
                                    />
                                </OKLink>
                            </div>
                            <SignaturePatternButton onClick={this.handleSubmit}>
                                <FormattedText
                                    value={`card${typeKey}Request-request`}
                                />
                            </SignaturePatternButton>
                        </footer>
                    </article>
                );
            }

            block = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover
                                size="medium"
                                section="cards"
                                customClass="col-xs-12"
                            >
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    tutorial={tutorial}
                                    finalTitle={getFinalTitle(pageTitleKey)}
                                >
                                    <CardHeaderDetails immCard={immCard} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {sectionContent}
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            block = <LoadingSection />;
        }

        if (immPrinter.get("isShowingPreview")) {
            return <PrintableGenericDocument>{block}</PrintableGenericDocument>;
        }

        return block;
    }
}

CardPinCvvRequestView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immPrinter: PropTypes.object,
    requestPin: PropTypes.func.isRequired,
    resetPin: PropTypes.func.isRequired,
    setPinExpired: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    routes: PropTypes.array,
    resetCvv: PropTypes.func.isRequired,
    setCvvExpired: PropTypes.func.isRequired,
    requestCvv: PropTypes.func.isRequired
};

module.exports.constructor = CardPinCvvRequestView;
module.exports.CardPinCvvRequestView = connect(
    state => ({
        immCards: state.cards,
        immPrinter: state.printer
    }),
    {
        requestPin: cardsPinActions.requestPin,
        resetPin: cardsPinActions.resetPin,
        setPinExpired: cardsPinActions.setExpired,
        requestCvv: cardCvvActions.requestCvv,
        resetCvv: cardCvvActions.resetCvv,
        setCvvExpired: cardCvvActions.setExpired
    }
)(withRouter(CardPinCvvRequestView));
